import React from 'react';
import { SpheraNotFound } from '@sphera-cloud/component-ui-reactjs';
import { useNavigate } from 'react-router-dom';
import { env } from 'src/config/env';

const NotFoundPage: React.FunctionComponent<{}> = () => {
  const navigate = useNavigate();

  const props = {
    innerWidth: '100%',
    errorMessage: 'Sorry, the page you requested was not found.',
    supportEmail: env.supportEmail,
    buttonText: 'Go Home',
    onBackButtonClick: () => {
      navigate('/');
    },
  };

  return <SpheraNotFound {...props} />;
};

export default NotFoundPage;
